import cn from 'classnames';
import type { FC } from 'react';
import type { GraphNodeBadge, GraphNodeTone } from './Nodes.utils';
import styles from './Nodes.module.scss';

const toneIconStyles: Record<GraphNodeTone, string> = {
  success: styles.toneSuccess,
  error: styles.toneError,
  neutral: styles.toneNeutral,
};

interface NodeBadgeProps {
  badge: GraphNodeBadge;
  /** Sizing and placement; the badge itself only owns its tone colour and spin. */
  className?: string;
  /**
   * Hides the icon from assistive tech when a visible label beside it already names the status, so it
   * isn't announced twice. The tooltip still shows on hover.
   */
  decorative?: boolean;
}

/** The badge icon of a {@link GraphNodeBadge}, coloured by tone. Shared so a status reads the same off the graph. */
const NodeBadge: FC<NodeBadgeProps> = ({ badge, className, decorative = false }) => (
  <badge.icon
    className={cn(className, toneIconStyles[badge.tone ?? 'neutral'], { [styles.spin]: badge.spin === true })}
    title={badge.tooltip}
    aria-hidden={decorative ? true : undefined}
    data-test-element="badge"
  />
);

export default NodeBadge;
